import script from "./ProjectContributeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectContributeButton.vue?vue&type=script&setup=true&lang=js"

import "./ProjectContributeButton.vue?vue&type=style&index=0&id=fd7065fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd7065fa"]])

export default __exports__